import { Component, OnInit, OnDestroy, TemplateRef, ViewContainerRef } from '@angular/core'
import { ActivatedRoute, Router } from '@angular/router';
import { ManageService } from '../../../../services/manage.service';
import { takeUntil } from 'rxjs/operators'
import { CSPSubscriptions, GetCSPSubscription, MCEUpgradeModel, ProductTerm } from '../../../../models/csp.model';
import { TransitionEligibility, TransitionType } from '../../../../models/transitionEligibility.mode';
import { Subject } from 'rxjs';
import { CommonService } from '../../../../services';
import { Transition } from '../../../../models/transition.model';
import { addDays, format } from 'date-fns';
import { MatDialog } from '@angular/material/dialog';
import { combineLatest } from 'rxjs';
import { AbstractControl, FormControl, FormGroup } from '@angular/forms';
import { CspTransitionSkuPipe } from '../../../../shared/pipes/sku-pipe';
import { ApiResponse } from '../../../../models/api-response.model';
import { ConfirmUpgradePopUpComponent } from '../../../../popup-collection/confirm-upgrade-pop-up/confirm-upgrade-pop-up.component';
import { PanelService } from '../../../../services/panel.service';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-confirm-upgrade',
  templateUrl: './confirm-upgrade.component.html',
  styleUrls: ['./confirm-upgrade.component.css'],
  providers: [DatePipe]
})
export class ConfirmUpgradeComponent implements OnInit, OnDestroy {

  title: string = 'Confirm Upgrade';
  public customEndDateTypeList = [
    'No Change',
    'Co-Term',
    'Align Calendar Month'
  ];
  loadContent: boolean = true;
  tenantId: string;
  subscriptionId: string;
  from: GetCSPSubscription;
  to: TransitionEligibility;
  transitionType: string;
  ngUnsubscribe: Subject<void> = new Subject<void>();
  isRenewLoaded = false;
  autoRenewalEnabled = false;
  autoRenewLoading = false;
  renewalLoading = false;
  billingLoading = false;
  customEndDateChanged = false;
  billingCycle: string;
  termDuration: string;
  fromText: string;
  qtyLoading = false;
  billingControl= new FormControl('');
  toSubscriptionControl = new FormControl(0);
  public subsForViewEndDates: CSPSubscriptions[];
  public subsForViewEndDatesBackUp: CSPSubscriptions[];

  public form = new FormGroup({
    toSubscription: new FormControl(0),
    toQty: new FormControl(0, this.validateQty.bind(this)),
    renewal: new FormControl(""),
    billing: new FormControl(""),
    customEndDate: new FormControl(""),
    customEndDateTypeControl: new FormControl('No Change')
  });

  public get toSubscription () {
    return this.form.get('toSubscription');
  }

  public get toQty() {
    return this.form.get('toQty');
  }

  public get renewal() {
    return this.form.get("renewal");
  }

  public get billing () {
    return this.form.get("billing");
  }



  getMCEUpgradeModel: MCEUpgradeModel = {} as MCEUpgradeModel;
  public existingSubList: CSPSubscriptions[];

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private manageService: ManageService,
    private commonService: CommonService,
    private vcr: ViewContainerRef,
    private cspTransitionSkuPipe: CspTransitionSkuPipe,
    private dialog: MatDialog,
    private datePipe: DatePipe,
    public sidenavService: PanelService
  ) {}

  async ngAfterViewInit() {
    await this.commonService.waitForElm('#levelOne');
    $('#levelOne').animate({ scrollLeft: $('#managecsp').width() + $('#upgradeSubscription').width() + 505 }, 400);
  }

  ngOnInit() {
    const combine$ = combineLatest([
      this.activatedRoute.parent.parent.params,
      this.activatedRoute.parent.params,
      this.manageService.currentMCESubscriptionUpgrade,
      this.manageService.currentExistingCSPSubscriptions
    ]).pipe(takeUntil(this.ngUnsubscribe));

    combine$.subscribe(([tenantParams, subParams, subs, subList]) => {
      this.tenantId = tenantParams['tenantId'];
      this.subscriptionId = subParams['sub'];

      if(subs != null) {
        this.from = subs.from;
        this.to = subs.to;
        console.log(this.to)
        let transition_type = 'transition_only';
        this.transitionType = transition_type;  
        this.isRenewLoaded = subs.isRenewLoaded;
        this.autoRenewalEnabled = subs.autoRenewalEnabled;
        this.toQty.setValue(!this.commonService.isNil(subs.changeToQty) ? subs.changeToQty : 0);
        // if (this.toQty.value) {
        //   this.toQty.valueChanges.subscribe(val => {
        //     if (!(Number(val) > 0)) {
        //       this.commonService.implementToast('Qty must be greater than 0', 'Error');
        //       return;
        //     }
        
        //     if (!this.autoRenewalEnabled) {
        //       if (Number(val) < Number(this.from.out_confirmed_qty)) {
        //         this.commonService.implementToast(`Qty must be greater than ${this.from.out_confirmed_qty}`, 'Error');
        //         return;
        //       }
        //     }
        //   });
        // }
        this.billingCycle = subs.billingCycle;
        this.termDuration = subs.termDuration;
        this.fromText = this.getAutoRenwewalText(this.autoRenewalEnabled,this.from);
        this.getMCEUpgradeModel = subs;
        // only load the same sku as the target sku subscriptions
        if (subList != null && this.to != null) {
          this.existingSubList = [ ...subList ].filter((sub) => {
            const [term, productId, skuId] = sub.baseSubscription.out_stock_code.split(':');
            const stockWithoutTerm = `${productId}:${skuId}`.toUpperCase();
            return stockWithoutTerm === this.cspTransitionSkuPipe.transform(this.to.catalogItemId);
          });
        }
      }
      if (subList?.length) {
        this.subsForViewEndDates = subList.filter(s => s.baseSubscription.out_charge_type === 'NCE' && (new Date(s.baseSubscription.out_expiry_date) > new Date()));
        if (this.subsForViewEndDates?.length <= 0) {
          const index = this.customEndDateTypeList.indexOf('Co-Term');
          if (index !== -1) {
            this.customEndDateTypeList.splice(index, 1);
          }
        }
      }
    });  
    
    this.renewal.valueChanges.pipe(takeUntil(this.ngUnsubscribe)).subscribe((term) => {
      this.UpdateSubscriptionCycle(term, this.from, "RENEWAL")
    })

    this.billingControl.valueChanges.pipe(takeUntil(this.ngUnsubscribe)).subscribe((term) => {
      this.UpdateSubscriptionCycle(term, this.from, "BILLING")
    })

  }

  async UpdateSubscriptionCycle(termDuration: string, subscription: GetCSPSubscription, action: string) {
    if(action == "RENEWAL") {
      this.termDuration = termDuration ? termDuration : this.getMCEUpgradeModel.termDuration;
    } else {
      this.billingCycle = termDuration ? termDuration : this.getMCEUpgradeModel.billingCycle;
    }
  }

  getAutoRenwewalText(autoRenewalEnabled: boolean, subscription: GetCSPSubscription): string {
    if (autoRenewalEnabled) {
      return `RENEWS ON ${format(addDays(new Date(subscription.out_expiry_date), 1), 'dd-MMM-yyyy')}`
    } else {
      return `EXPIRY ON ${format(new Date(subscription.out_expiry_date), 'dd-MMM-yyyy')}`
    }
  }
  isSubInProgress(subscription: GetCSPSubscription): boolean {
    return !this.commonService.isEmpty(subscription) && subscription.out_status_desc.includes('In Progress')
  }

  getRenewDate(subscription: GetCSPSubscription) {
    let renew_date = '';
    if (subscription.out_expiry_date) {
      renew_date = format(addDays(Number(subscription.out_expiry_date), 1), 'DD-MMM-YYYY');
    }
    return renew_date.toUpperCase();
  }
  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  postTransition() {
    const dialogRef = this.dialog.open(
      ConfirmUpgradePopUpComponent,
      {
        width: '350px',
        data: {
          tenantId: this.tenantId,
          term: this.renewal.value ? this.renewal.value : this.termDuration,
          catalogItemId: this.to?.catalogItemId,
          originalProduct: this.from,
          toQty: this.toQty.value,
          commitmentEndDate: this.getMCEUpgradeModel?.commitmentEndDate,
          stockGroup: this.manageService.currentProductPricingV2?.out_stock_group
        }
      }
    );

    dialogRef.afterClosed().subscribe(result => {
      if (result?.action == 'Immediately') {
        let transition = {
          toCatalogItemId: this.to.catalogItemId,
          quantity: this.toQty.value ? this.toQty.value : 0,
          transitionType: TransitionType.TRANSITION_ONLY,
          term: this.termDuration,
          billingCycle: this.billingCycle,
          toSubscriptionId:  this.toSubscription.value ? this.toSubscription.value.toLowerCase() : null
        } as Transition
    
        this.loadContent = false;
        this.manageService.PostTransition(
          this.tenantId.toLocaleLowerCase(),
          this.subscriptionId.toLocaleLowerCase(),
          this.from.out_stock_code.toLocaleLowerCase(),
          this.from.out_offer_uri.toLocaleLowerCase(),
          this.from.out_expiry_date,
          transition
        )
          .pipe(takeUntil(this.ngUnsubscribe))
          .subscribe({
            next: (res: any) => {

              if ((res as ApiResponse)?.status == false) {
                this.commonService.implementToast(res?.responseMessage, 'Error')
              } else {
                this.commonService.implementToast("Transition in progress. Avoid any changes to this customer’s subscription. It usually takes 24 hours for automatic license assignment. If license assignment is taking longer, you may need to assign them manually.", "Success")
                this.manageService.refetchCSPItemsView$.next();
                this.manageService.backToTenentPage(this.tenantId);
              }
            },
            complete: () => this.loadContent = true
          });
      } else if (result?.action == 'ScheduleNew') {

        console.log(result)
        let productTerm = {} as ProductTerm;

        let [term, productId, skuId] = this.from.out_stock_code.split(':');

        productTerm.productId = productId;

        productTerm.skuId = skuId;

        productTerm.termDuration = this.termDuration;

        let billingFreqStr = this.billingCycle;

        productTerm.billingCycle = this.commonService.parseToBillingCyleType(billingFreqStr);

        //productTerm.availabilityId = '';

        productTerm.availabilityId = this.getMCEUpgradeModel?.offerId;

        let customEndDate: string;
        if (this.customEndDateChanged) {
          const date = new Date(
            this.form.get('customEndDate').value.year,
            this.form.get('customEndDate').value.month - 1,
            this.form.get('customEndDate').value.day
          )
          customEndDate = this.datePipe.transform(date, 'yyyy-MM-dd')
        }

        this.loadContent = false;
        this.manageService.UpdateSubscriptionCycle(
          this.tenantId.toLocaleLowerCase(),
          this.subscriptionId.toLocaleLowerCase(),
          result?.product?.stockCode.toLocaleLowerCase(),
          result?.product?.offerId.toLocaleLowerCase(),
          this.toQty.value ? this.toQty.value : 0,
          'RENEWAL',
          this.from.out_expiry_date,
          productTerm,
          customEndDate ? customEndDate + ' 23:59:00' : null
        )
          .pipe(takeUntil(this.ngUnsubscribe))
          .subscribe({
            next: (res: any) => {
              if (res?.status == false) {
                this.commonService.implementToast(res?.responseMessage, 'Error')
              } 
              this.manageService.refetchCSPItemsView$.next();
              this.manageService.backToTenentPage(this.tenantId);
            },
            complete: () => this.loadContent = true
          });
        
        
        // .subscribe((res: any) => {
        //   if (res?.status == false) {
        //     this.commonService.implementToast(res?.responseMessage, 'Error')
        //   } 
        //   this.manageService.refetchCSPItemsView$.next();
        //   this.renewalLoading = this.billingLoading = this.qtyLoading = this.customEndDateLoading = false;
        // },
        //   (error) => {
        //     this.renewalLoading = this.billingLoading = this.qtyLoading = this.customEndDateLoading = false;
        //   }
        // );
      }
    })
  }

  /**
   * A custom validator checks the Qty input is within the range
   */ 
  private validateQty(control: AbstractControl): any {
    const qty = control.value
    if (!(qty > 0)) {
      return { zeroError: true };
    }

    if (!this.autoRenewalEnabled) {
      if (qty < Number(this.from.out_confirmed_qty)) {
        return { confirmQtyError: true };
      }
    }
    return null;
  }

  onLoading(currentLoadingStatus: boolean) {
    this.loadContent = !currentLoadingStatus;
  }

  changeEndDate(value, tempRef?: TemplateRef<any>) {
    let dateToChange = {}
    if (value == 'Align Calendar Month') {
      if (this.sidenavService?.panel?.opened) {
        this.sidenavService.panel.close()
      }

      /**
       * !!!!!!!!!!!
       * Date obj month starts from 0
       * DatePicker(UI) obj month starts from 1
       */
      const expDate = new Date(this.from.out_expiry_date);
      console.log(expDate)
      let year = expDate.getFullYear();
      let month = expDate.getMonth() + 1;
      let day = expDate.getDate();
      if (
        // change term from month to annual
        (
          this.renewal.value === 'P1Y' && !this.termDuration.includes('P1Y')
        ) || 
        // was annual and no change in term
        (
          this.renewal.value === '' && this.termDuration.includes('P1Y')
        )
      ) {
        year += 1;
        // error case: 30/10/2023
        // wrong: 31/10/2024   correct: 30/9/2024
        if (new Date(year, month, 0).getDate() > day) {
          if (month == 1) {
            month = 12;
            year -= 1;
          } else {
            month -= 1
          }
        }
      } else if (this.termDuration.includes('P3Y')) {
        year += 3;
      } else if (this.termDuration.includes('P1M')) {

        /**
         * https://learn.microsoft.com/en-us/partner-center/align-subscription-end-dates#one-month-term-subscription-example
         * 
         * The custom term end date must be within the first term duration, and for monthly term products,
         * it cannot align with a subscription ending on the 28th, 29th, or 30th of the month, unless that date is the last day of the month.
         * 
         */
        const endDay = expDate.getDate();
        // const lastDay = new Date(year,  month, 0).getDate();
        if (endDay >= 28) {
          month = month === 12 ? 1 : month + 1;
        }
      }

      day = new Date(year, month, 0).getDate();
      console.log(new Date(year, month, 0))
      dateToChange = { year, month, day };

    } else if (value == 'Co-Term') {
      this.openRightPanel(tempRef)
    } else {
      if (this.sidenavService?.panel?.opened) {
        this.sidenavService.panel.close()
      }
    }

    if (!this.commonService.isEmpty(dateToChange)) {
      this.form.get('customEndDate').setValue(dateToChange);
      this.customEndDateChanged = true;
    } else {
      this.form.get('customEndDate').setValue(null);
      this.customEndDateChanged = false;
    }
  }

  openRightPanel(tempRef: TemplateRef<any>) {
    if (this.sidenavService?.panel?.opened) {
      this.sidenavService.panel.close()
    } else {
      this.sidenavService.setViewContainerRef(this.vcr);
      this.sidenavService.setPanelContent(tempRef);
      this.sidenavService.open();
    }
  }

  assignEndDate(date: string): void {
    const selectedDate = new Date(date);
    const originCustomEndDate = new Date(this.from.out_expiry_date);
    const originDay = originCustomEndDate.getDate();
    const originMonth = originCustomEndDate.getMonth() + 1;
    const originYear = originCustomEndDate.getFullYear();
    let dateToChange: any = null;
    if (originCustomEndDate > selectedDate) {
      // need to align it with next term co-term date
      let coTermDate = new Date();

      if (this.termDuration == "P1M") {
        coTermDate = new Date(selectedDate.getFullYear(), selectedDate.getMonth() + 1, selectedDate.getDate());
        if (originCustomEndDate > coTermDate) {
          coTermDate = new Date(coTermDate.setMonth(coTermDate.getDate() + 2));
        }
      }
      else if (this.termDuration == "P1Y") {
        coTermDate = new Date(selectedDate.getFullYear() + 1, selectedDate.getMonth(), selectedDate.getDate());
          if (originCustomEndDate > coTermDate) {
          coTermDate = new Date(coTermDate.setFullYear(coTermDate.getFullYear() + 1));
        }
      }
      else if (this.termDuration == "P3Y") {
        coTermDate = new Date(selectedDate.getFullYear() + 3, selectedDate.getMonth(), selectedDate.getDate());
        if (originCustomEndDate > coTermDate) {
          coTermDate = new Date(coTermDate.setFullYear(coTermDate.getFullYear() + 3));
        }
      }
      dateToChange = { day: coTermDate.getDate(), month: coTermDate.getMonth() + 1, year: coTermDate.getFullYear() };

    }
    else {
      dateToChange = { day: selectedDate.getDate(), month: selectedDate.getMonth() + 1, year: selectedDate.getFullYear() };
    }
    this.form.get('customEndDate').setValue(dateToChange);
    this.commonService.implementToast('Expiry date applied!', 'Success');
    if (originDay != dateToChange.day || originMonth != dateToChange.month || originYear != dateToChange.year) {
      this.customEndDateChanged = true;
    } else {
      this.customEndDateChanged = false;
    }
    this.sidenavService.panel.close()
  }

  close() {
    $('#levelOne').animate({ scrollLeft: $('#managecsp').width() + 505 }, 400);
    this.router.navigate(['../../'], { relativeTo: this.activatedRoute })
  }

}
